import { Injectable } from '@angular/core';
import { companyConfigService } from './core/services/company-config.service';
import { HttpClient } from '@angular/common/http';
import { catchError, firstValueFrom, forkJoin, map, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppConstants_settings } from './core/AppConstants_Appsettings.enum';
import { ICompanyconfigModel } from './models/config-model';
import { ApiService } from './core/services/api.service';
import { IndexedDbService } from './core/services/indexed-dbservice.service';
import { CurrencySettingsService } from './core/services/currency-setting.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private _initPromise: Promise<void> | null = null;

  configmodel: ICompanyconfigModel = {
    CompanyConfig: {},
    DBConfig: {},
    GuestToken: {}
  };

  compId: any;

  constructor(
    private http: HttpClient,
    private companyConfigService: companyConfigService,
    private store: Store,
    private api: ApiService,
    private dbService: IndexedDbService,
    private currencySettings: CurrencySettingsService,
    private cookieService: CookieService
  ) { }

  async init(): Promise<void> {

    if (this._initPromise) {
      return this._initPromise;
    }

    this._initPromise = (async () => {
      try {
        const dbConfig = await firstValueFrom(
          this.http.get(
            environment.BACKOFFICE_URL + '/Login/GetWebsiteData'
          ).pipe(
            catchError(() => of(null))
          )
        );

        let matchedConfig = (dbConfig as any[])?.find(x =>
          x.url?.includes(window.location.host)
        );

        this.compId = matchedConfig?.companyId || 'NS';
        let token: string | null = null;
        if (window.location.search.includes('token')) {
          const params = new URLSearchParams(window.location.search);
          token = params.get('token');
          if (token) {
            localStorage.setItem('BOC_TOKEN', token);
            localStorage.setItem('ACTIVE_CHANNEL', 'BOC');
          }
        }
        else if (localStorage.getItem('ACTIVE_CHANNEL') === 'BOC' && window.location.pathname != '/flight') {
          token = localStorage.getItem('BOC_TOKEN');
        }
        else {
          localStorage.removeItem('BOC_TOKEN');
          localStorage.removeItem('ACTIVE_CHANNEL');
          token = null;
        }
        if (token) {
          const tok = JSON.parse(atob(token.split('.')[1]));
          const branchId = tok?.branchId;
          if (window.location.search.includes('activeid')) {
            const params = new URLSearchParams(window.location.search);
            (AppConstants_settings as any).ActiveBOC_ID = params.get('activeid');
            localStorage.setItem('ActiveBOC_ID', JSON.stringify(params.get('activeid')));
          }
          else {
            (AppConstants_settings as any).ActiveBOC_ID = JSON.parse(localStorage.getItem('ActiveBOC_ID')!);
          }

          (AppConstants_settings as any).ACTIVE_CHANNAL = 'BOC';
          (AppConstants_settings as any).BRANCH_ID = branchId;
          (AppConstants_settings as any).CHANNEL = 'BOC';
        }
        else {
          const savedChannel = localStorage.getItem('ACTIVE_CHANNEL');
          if (savedChannel === 'BOC') {
            (AppConstants_settings as any).ACTIVE_CHANNAL = 'BOC';
            (AppConstants_settings as any).CHANNEL = 'BOC';
          }
          else {
            (AppConstants_settings as any).ACTIVE_CHANNAL = 'B2C';
            (AppConstants_settings as any).CHANNEL =
              matchedConfig?.urlType || 'B2C';
            localStorage.setItem('ACTIVE_CHANNEL', 'B2C');
          }
        }
        (AppConstants_settings as any).COMPANY_ID = this.compId;
        const { companyConfig, GuestToken } = await firstValueFrom(
          forkJoin({

            companyConfig: this.api.companySettings(this.compId).pipe(
              map((res: any) =>
                res?.jsondata ? JSON.parse(res.jsondata) : null
              ),
              catchError(() => of(null))
            ),

            GuestToken: this.http.post(
              environment.B2CAPI_URL + 'SignIn/GuestSignIn',
              { companyId: this.compId }
            ).pipe(
              catchError(() => of(null))
            ),

          })
        );
        if (dbConfig) {
          this.companyConfigService.setDbConfig(dbConfig);
        }

        if (companyConfig) {
          this.companyConfigService.setCompanyConfig(companyConfig);
          this.dbService.setData('websiteSetting', companyConfig);
        }
        if (GuestToken) {

          this.companyConfigService.setGuestToken(GuestToken);

          let gToken = JSON.parse(JSON.stringify(GuestToken))?.guesttoken;

          if (gToken) {
            this.cookieService.set('guestToken', gToken, {
              path: '/',
              sameSite: 'Lax'
            });
          }
        }
      } catch (err) {
        console.error('Init Failed:', err);
        return;
      }
    })();
    return this._initPromise;
  }
}
